<template>
  <div class="about-info">
    <div class="facts-row">
      <div class="fact-wrapper">
        <div class="top">
          <svg class="icon" viewBox="0 0 512 512">
            <g>
              <path
                d="M243.3,3L15.7,116.8C6.1,121.6,0,131.4,0,142.2c0,10.8,6.1,20.6,15.7,25.4l227.6,113.8c8,4,17.5,4,25.4,0l227.6-113.8
      c9.7-4.8,15.7-14.6,15.7-25.4c0-10.8-6.1-20.6-15.7-25.4L268.7,3c-14.1-7-31.1-1.3-38.2,12.7c-7,14.1-1.3,31.1,12.7,38.2
      l176.7,88.3l-163.9,82l-163.9-82l176.7-88.3c14.1-7,19.7-24.1,12.7-38.2C274.4,1.7,257.3-4,243.3,3L243.3,3z"
              />
              <path
                d="M15.7,281.4l227.6,113.8c8,4,17.5,4,25.4,0l227.6-113.8c14.1-7,19.7-24.1,12.7-38.2c-7-14.1-24.1-19.7-38.2-12.7L256,338
      L41.2,230.6c-14.1-7-31.1-1.3-38.2,12.7C-4,257.3,1.7,274.4,15.7,281.4L15.7,281.4z"
              />
              <path
                d="M15.7,395.2L243.3,509c8,4,17.5,4,25.4,0l227.6-113.8c14.1-7,19.7-24.1,12.7-38.2c-7-14.1-24.1-19.7-38.2-12.7L256,451.8
      L41.2,344.3C27.1,337.3,10,343,3,357.1C-4,371.1,1.7,388.2,15.7,395.2L15.7,395.2z"
              />
            </g>
          </svg>
          <span class="fact">
            <span class="number-counter animate"></span>
            <span class="more">+</span>
          </span>
        </div>
        <div class="text">Years of Experience</div>
      </div>
      <div class="fact-wrapper">
        <div class="top">
          <svg class="icon" viewBox="0 0 512 512">
            <g>
              <path
                d="M430.55,0H81.45c-12.8,0-23.27,10.47-23.27,23.27v465.45c0,12.8,10.47,23.27,23.27,23.27h349.09
      c12.8,0,23.27-10.47,23.27-23.27V23.27C453.82,10.47,443.35,0,430.55,0z M407.27,465.45H104.73V46.55h302.55V465.45z M160,311.27
      c0-11.06,9.31-20.36,20.36-20.36h68.65c11.06,0,20.36,9.31,20.36,20.36s-9.31,20.36-20.36,20.36h-68.65
      C168.73,331.64,160,322.33,160,311.27z M162.91,218.18c0-11.06,9.31-20.36,20.36-20.36h138.47c11.06,0,20.36,9.31,20.36,20.36
      c0,11.06-8.73,20.36-20.36,20.36H183.27C172.22,238.55,162.91,229.24,162.91,218.18z M162.91,130.91
      c0-11.05,9.31-20.36,20.36-20.36h138.47c11.06,0,20.36,9.31,20.36,20.36s-8.73,20.36-20.36,20.36H183.27
      C172.22,151.27,162.91,141.96,162.91,130.91z M335.71,298.47c3.49,3.49,5.82,8.73,5.82,14.55c0,5.24-2.33,10.47-5.82,14.55
      c-3.49,4.07-9.31,5.82-14.55,5.82c-5.24,0-10.48-2.32-14.55-5.82c-4.07-3.49-5.82-8.73-5.82-14.55c0-5.23,2.32-10.47,5.82-14.55
      C314.18,290.91,328.14,290.91,335.71,298.47z"
              />
            </g>
          </svg>
          <span class="fact">
            <span class="number-counter -projects animate"></span>
            <span class="more">+</span>
          </span>
        </div>
        <div class="text">Projects Completed</div>
      </div>
      <div class="fact-wrapper">
        <div class="top">
          <svg class="icon" viewBox="0 0 512 512">
            <g>
              <path
                d="M46.28,260.69l13.77-10.33c-17.09-22.78-25.62-49.85-25.61-76.23c0-21.99,5.9-43.38,17.47-61.48
      c11.6-18.11,28.75-33.09,52.42-42.59c14.63-5.84,27.56-8.15,39.16-8.15c24.43,0.03,44.08,10.24,60.22,24.38
      c16.01,14.06,27.66,32.04,33.79,44.37c2.92,5.84,8.87,9.52,15.4,9.52c6.53,0,12.48-3.67,15.4-9.52
      c5.32-10.86,19.49-29.17,38.86-43.47c19.45-14.49,43.75-25.3,70.73-25.27c12.79,0.01,26.33,2.37,40.81,8.15
      c21.14,8.51,35.32,21.08,44.8,36.28c9.43,15.21,14.06,33.43,14.07,53.07c0.06,30.38-11.38,63.79-31.81,90.95
      c-12.11,16.17-31.17,37.41-52.7,59.72c-32.32,33.52-70.29,69.69-100.12,97.41c-14.92,13.86-27.8,25.62-36.95,33.9
      c-9.15,8.28-14.51,13.05-14.52,13.06l11.44,12.87l11.44-12.87c-0.01-0.01-2.37-2.11-6.69-5.99c-15.09-13.57-53.63-48.54-93.91-87.5
      c-40.22-38.86-82.43-82.17-103.69-110.6L46.28,260.69L32.5,271.02c13.72,18.27,33.4,40.07,55.46,62.96
      c66.08,68.51,153.34,146.05,153.5,146.2c6.52,5.8,16.35,5.8,22.88,0c0.09-0.08,38.95-34.62,84.38-77.89
      c22.72-21.64,47.08-45.46,69.13-68.32c22.06-22.89,41.74-44.69,55.46-62.96c24.66-32.97,38.64-72.81,38.7-111.61
      c0.01-25.02-5.95-49.77-19.23-71.21c-13.24-21.45-33.9-39.22-61.28-50.12c-18.41-7.37-36.5-10.63-53.6-10.62
      c-36.34,0.02-67.57,14.41-91.3,32.09c-23.82,17.86-40.48,38.68-49.09,55.69l15.4,7.7l15.4-7.7c-7.81-15.53-21.35-36.68-41.81-54.79
      c-20.33-18.02-48.42-33.02-83-32.99c-16.25-0.01-33.7,3.31-51.95,10.62C61.39,50.1,38.19,70.09,22.89,94.11
      C7.55,118.12,0,146,0,174.13c0,33.75,10.85,68.02,32.5,96.9L46.28,260.69z"
              />
            </g>
          </svg>
          <span class="fact">
            <span class="number-counter -satisfaction animate"></span>
            <span class="more">+</span>
          </span>
        </div>
        <span class="text">Hours of Coding</span>
      </div>
    </div>
    <div class="author-row">
      <div class="author-image fade-in-slide-left animate">
        <lazy-component>
          <picture>
            <source
              srcset="
                ~@/assets/img/profile.webp     500w,
                ~@/assets/img/profile-250.webp 250w,
                ~@/assets/img/profile-150.webp 150w
              "
              type="image/webp"
            />
            <source
              srcset="
                ~@/assets/img/profile-original.jpg     500w,
                ~@/assets/img/profile-original-250.jpg 250w,
                ~@/assets/img/profile-original-150.jpg 150w
              "
            />
            <img
              class="image"
              src="~@/assets/img/profile-original.jpg"
              alt="Ovidijus profile image"
            />
          </picture>
        </lazy-component>
      </div>
      <p class="info fade-in-slide-right animate">
        Full stack developer with over 3 years of experience in web development.
        Professional with a passion for fast, user-friendly and effective
        websites that actually work.
      </p>
    </div>
    <div>
      <div class="languages-row">
        <span class="icon fade-in-slide-up animate">
          <svg viewBox="0 0 512 512">
            <title>HTML5</title>
            <path
              d="M108.4 0h23v22.8h21.2V0h23v69h-23V46h-21v23h-23.2M206 23h-20.3V0h63.7v23H229v46h-23M259.5 0h24.1l14.8 24.3L313.2 0h24.1v69h-23V34.8l-16.1 24.8l-16.1-24.8v34.2h-22.6M348.7 0h23v46.2h32.6V69h-55.6"
            />
            <path
              fill="#e44d26"
              d="M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"
            />
            <path fill="#f16529" d="M256 480.5V131H404.3L376 447" />
            <path
              fill="#ebebeb"
              d="M142 176.3h114v45.4h-64.2l4.2 46.5h60v45.3H154.4M156.4 336.3H202l3.2 36.3 50.8 13.6v47.4l-93.2-26"
            />
            <path
              fill="#fff"
              d="M369.6 176.3H255.8v45.4h109.6M361.3 268.2H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8"
            />
          </svg>
        </span>
        <span class="icon fade-in-slide-up animate">
          <svg viewBox="0 0 128 128">
            <title>CSS3</title>
            <path
              fill="#1572B6"
              d="M19.67 26l8.069 90.493 36.206 10.05 36.307-10.063 8.078-90.48h-88.66zm69.21 50.488l-2.35 21.892.009 1.875-22.539 6.295v.001l-.018.015-22.719-6.225-1.537-17.341h11.141l.79 8.766 12.347 3.295-.004.015v-.032l12.394-3.495 1.308-14.549h-25.907000000000004l-.222-2.355-.506-5.647-.265-2.998h27.886000000000003l1.014-11h-42.473l-.223-2.589-.506-6.03-.265-3.381h55.597l-.267 3.334-2.685 30.154"
            />
            <path
              fill="#1572B6"
              d="M89 14.374l-7.149-8.374h7.149v-5h-16v4.363l8.39 7.637h-8.39v5h16zM70 14.374l-6.807-8.374h6.807v-5h-15v4.363l7.733 7.637h-7.733v5h15zM52 13h-8v-7h8v-5h-14v17h14z"
            />
          </svg>
        </span>
        <span class="icon -js fade-in-slide-up animate">
          <svg viewBox="0 0 397.31802 559.50037">
            <title>Javascript</title>
            <path
              style="fill: #ffffff; stroke-width: 1.33333337"
              d="m 1.33372,109.33203 0.0625,5 c 0.03444,2.75 8.00162,93.80066 17.70507,202.33399 L 36.74387,514 l 79.29492,22.20117 c 43.61211,12.21062 80.19493,22.26265 81.29493,22.33985 1.1,0.0771 38.16591,-9.87392 82.36914,-22.11329 70.87044,-19.6232 80.43786,-22.57875 80.94531,-25.00781 0.707,-3.38418 35.41255,-394.89905 35.37695,-399.08789 l -0.0254,-3 H 198.66575 Z"
            />
            <path
              d="m 116.66667,537.52932 -80,-22.36163 -1.04545,-5.91717 C 34.69191,503.99074 0,116.51622 0,111.3966 c 0,-1.85291 20.25565,-2.06327 198.66667,-2.06327 188.32331,0 198.66587,0.12147 198.65133,2.33333 -0.0628,9.55335 -35.97164,402.15858 -36.85409,402.94002 -1.11511,0.98746 -155.95653,44.12552 -161.13057,44.89017 -1.46667,0.21676 -38.66667,-9.66863 -82.66667,-21.96753 z M 249.11103,458.5163 c 26.88893,-7.41602 49.27699,-13.86602 49.75121,-14.33333 0.47423,-0.46731 3.62071,-32.34964 6.99216,-70.84964 3.37146,-38.5 6.47022,-72.55 6.88612,-75.66667 L 313.49674,292 h -58.08171 -58.08169 v 24.66666 24.66667 h 31.35873 31.35873 l -0.6238,3 c -0.34309,1.65 -1.67673,15.82935 -2.96364,31.50967 -1.36361,16.6149 -2.98028,29.1501 -3.87486,30.04469 -0.84427,0.84427 -13.62206,4.75671 -28.3951,8.69431 l -26.86006,7.15929 v 25.12935 c 0,17.15185 0.45852,25.12936 1.44436,25.12936 0.7944,0 23.4444,-6.06767 50.33333,-13.4837 z M 312.73228,261 C 311.85092,254.46662 304,166.83717 304,163.53304 c 0,-2.00692 -4.61566,-2.19971 -52.66666,-2.19971 h -52.66667 v 25.79372 25.79373 l 23.66667,0.91218 c 13.01666,0.50169 26.71548,1.26522 30.4418,1.69674 l 6.77512,0.78459 1.64474,20.17619 c 0.9046,11.0969 1.98248,22.42618 2.39528,25.17618 l 0.75055,5 h 24.57795 24.57796 z"
              style="fill: #eaebec; stroke-width: 1.33333337"
            />
            <path
              d="M 116.0386,536.2011 36.74387,514 19.10122,316.66666 C 9.39776,208.13333 1.43039,117.08333 1.39595,114.33333 l -0.0626,-5 H 198.66667 396 l 0.0256,3 c 0.0356,4.18884 -34.67072,395.70379 -35.37772,399.08797 -0.50745,2.42906 -10.07454,5.38483 -80.94498,25.00803 -44.20323,12.23937 -81.26951,22.19028 -82.36951,22.11315 -1.1,-0.0772 -37.68263,-10.13076 -81.29473,-22.34138 z m 133.13264,-76.74193 c 27.41084,-7.62076 50.2269,-14.48533 50.70234,-15.2546 0.47542,-0.76927 3.75001,-34.28 7.27684,-74.46829 3.52682,-40.18828 6.70121,-74.11962 7.05418,-75.40295 C 314.81095,292.12877 310.14694,292 229.69083,292 H 144.5353 l 3.62565,-38.33334 c 1.99411,-21.08333 3.67367,-38.38792 3.73235,-38.45464 0.0587,-0.0667 12.5567,-0.46537 27.77337,-0.8859 24.95099,-0.68958 76.40477,1.30088 78.12613,3.02224 0.64308,0.64308 4.87387,42.15037 4.87387,47.81645 0,2.79381 0.37699,2.83519 25.83621,2.83519 h 25.83623 l -0.60884,-5.66667 c -0.33487,-3.11667 -2.52341,-27.26667 -4.86345,-53.66667 l -4.25462,-48 -99.63942,-0.34182 c -79.26871,-0.27194 -99.64168,6.5e-4 -99.65038,1.33333 -0.007,0.92135 -0.58701,6.77516 -1.29109,13.00849 -1.70375,15.08355 -14.697967,160.82251 -14.697967,164.84759 v 3.15241 h 84.783857 84.78387 l -0.75581,5 c -0.4157,2.75 -1.73364,16.7 -2.92876,31 -1.19512,14.3 -2.55774,26.3694 -3.02806,26.82091 -1.24218,1.19249 -51.11936,14.51707 -54.22958,14.48731 -1.44404,-0.0138 -14.32552,-3.22779 -28.62552,-7.14216 l -26,-7.11703 -0.95343,-11.19119 c -0.52439,-6.15514 -1.32215,-14.94117 -1.7728,-19.5245 l -0.81936,-8.33334 h -25.2272 -25.227207 l 0.0559,5 c 0.1044,9.35062 6.16783,72.33478 7.04834,73.21528 1.01833,1.01835 97.912237,28.25511 100.895817,28.36171 1.1,0.0393 24.42706,-6.16372 51.83791,-13.78448 z"
              style="fill: #f0be25; stroke-width: 1.33333337"
            />
            <path
              d="M 116.0386,536.2011 36.74387,514 19.10122,316.66666 C 9.39776,208.13333 1.43039,117.08333 1.39595,114.33333 l -0.0626,-5 H 198.66667 396 l 0.0256,3 c 0.0356,4.18884 -34.67072,395.70379 -35.37772,399.08797 -0.50745,2.42906 -10.07454,5.38483 -80.94498,25.00803 -44.20323,12.23937 -81.26951,22.19028 -82.36951,22.11315 -1.1,-0.0772 -37.68263,-10.13076 -81.29473,-22.34138 z m 147.87439,-29.70081 c 34.88119,-9.62484 64.07555,-18.17484 64.87636,-19 C 330.0356,486.21612 360.16146,156.04608 360.04024,145 l -0.0402,-3.66667 H 279.33338 198.66671 V 150.66666 160 H 152 c -36.43861,0 -46.66906,0.36529 -46.6776,1.66666 -0.007,0.91667 -0.58701,6.76667 -1.29109,13 -1.70375,15.08355 -14.697967,160.82251 -14.697967,164.84759 v 3.15241 H 144 198.66667 v 38.66667 c 0,30.05784 -0.37107,38.66108 -1.66667,38.64155 -0.91666,-0.0139 -13.36666,-3.22779 -27.66666,-7.14216 l -26,-7.11703 -0.95343,-11.19119 c -0.52439,-6.15514 -1.32215,-14.94117 -1.7728,-19.5245 l -0.81936,-8.33334 h -25.2272 -25.227207 l 0.0559,5 c 0.15972,14.30148 6.3465,72.67926 7.79746,73.576 0.8819,0.54504 24.075687,7.2095 51.541737,14.80988 l 49.93823,13.81888 v 25.06428 c 0,13.78536 0.41084,25.0643 0.91299,25.0643 0.50213,0 29.45213,-7.87487 64.33333,-17.49971 z M 148.02046,254.02497 c 1.91684,-20.88627 3.7464,-38.21141 4.06569,-38.50032 0.31928,-0.28889 10.93052,-0.81163 23.58052,-1.16161 l 23,-0.63635 V 252.86334 292 H 171.60098 144.5353 Z"
              style="fill: #e4a126; stroke-width: 1.33333337"
            />
            <path
              d="M 126.66667,62 V 49.33333 h 18 18 V 24.666666 0 H 175.33334 188 V 37.333333 74.66666 H 157.33334 126.66667 Z M 200,64.66667 v -10 h 16.66667 c 9.16667,0 16.66667,-0.33886 16.66667,-0.75302 0,-0.41416 -7.5,-8.881457 -16.66667,-18.816218 L 200,17.034229 V 8.517114 0 h 34.66667 34.66667 v 9.958961 9.958961 l -16.2745,0.374372 -16.27449,0.374372 16.94116,18.244279 16.94116,18.244275 v 8.75572 8.75572 H 235.33334 200 Z"
              style="fill: #0e0e0f; stroke-width: 1.33333337"
            />
          </svg>
        </span>
        <span class="icon -webpack fade-in-slide-up animate">
          <svg viewBox="0 0 774 875.7">
            <title>Webpack</title>
            <path
              fill="#FFF"
              d="M387 0l387 218.9v437.9L387 875.7 0 656.8V218.9z"
            />
            <path
              fill="#8ed6fb"
              d="M704.9 641.7L399.8 814.3V679.9l190.1-104.6 115 66.4zm20.9-18.9V261.9l-111.6 64.5v232l111.6 64.4zM67.9 641.7L373 814.3V679.9L182.8 575.3 67.9 641.7zM47 622.8V261.9l111.6 64.5v232L47 622.8zm13.1-384.3L373 61.5v129.9L172.5 301.7l-1.6.9-110.8-64.1zm652.6 0l-312.9-177v129.9l200.5 110.2 1.6.9 110.8-64z"
            />
            <path
              fill="#1c78c0"
              d="M373 649.3L185.4 546.1V341.8L373 450.1v199.2zm26.8 0l187.6-103.1V341.8L399.8 450.1v199.2zm-13.4-207zM198.1 318.2l188.3-103.5 188.3 103.5-188.3 108.7-188.3-108.7z"
            />
          </svg>
        </span>
        <span class="icon fade-in-slide-up animate">
          <svg viewBox="0 0 261.76 226.69">
            <title>Vue.js</title>
            <g transform="matrix(1.3333 0 0 -1.3333 -76.311 313.34)">
              <g transform="translate(178.06 235.01)">
                <path
                  d="m0 0-22.669-39.264-22.669 39.264h-75.491l98.16-170.02 98.16 170.02z"
                  fill="#41b883"
                />
              </g>
              <g transform="translate(178.06 235.01)">
                <path
                  d="m0 0-22.669-39.264-22.669 39.264h-36.227l58.896-102.01 58.896 102.01z"
                  fill="#34495e"
                />
              </g>
            </g>
          </svg>
        </span>
        <span class="icon fade-in-slide-up animate">
          <svg viewBox="0 0 400 298">
            <title>Nuxt.js</title>
            <g>
              <path
                fill="#00C58E"
                d="M227.92099 82.07407l-13.6889 23.7037-46.8148-81.08641L23.7037 273.58025h97.3037c0 13.0912 10.61252 23.7037 23.70371 23.7037H23.70371c-8.46771 0-16.29145-4.52017-20.5246-11.85382-4.23315-7.33366-4.23272-16.36849.00114-23.70174L146.89383 12.83951c4.23415-7.33433 12.0596-11.85252 20.5284-11.85252 8.46878 0 16.29423 4.51819 20.52839 11.85252l39.97037 69.23456z"
              />
              <path
                fill="#2F495E"
                d="M331.6642 261.7284l-90.05432-155.95062-13.6889-23.7037-13.68888 23.7037-90.04445 155.95061c-4.23385 7.33325-4.23428 16.36808-.00113 23.70174 4.23314 7.33365 12.05689 11.85382 20.5246 11.85382h166.4c8.46946 0 16.29644-4.51525 20.532-11.84955 4.23555-7.3343 4.23606-16.37123.00132-23.706h.01976zM144.7111 273.58024L227.921 129.48148l83.19012 144.09877h-166.4z"
              />
              <path
                fill="#108775"
                d="M396.04938 285.4321c-4.23344 7.33254-12.05656 11.85185-20.52345 11.85185H311.1111c13.0912 0 23.7037-10.6125 23.7037-23.7037h40.66173L260.09877 73.74815l-18.4889 32.02963-13.68888-23.7037L239.5753 61.8963c4.23416-7.33433 12.0596-11.85252 20.5284-11.85252 8.46879 0 16.29423 4.51819 20.52839 11.85252l115.41728 199.8321c4.23426 7.33395 4.23426 16.36975 0 23.7037z"
              />
            </g>
          </svg>
        </span>
        <span class="icon -strapi fade-in-slide-up animate">
          <svg viewBox="0 0 569 151">
            <title>Strapi</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                id="Logo-White-Background"
                transform="translate(-436.000000, -387.000000)"
              >
                <g id="Logo" transform="translate(435.000000, 387.000000)">
                  <g transform="translate(0.000000, 23.000000)" fill="#8E75FF">
                    <g>
                      <path
                        d="M86.1180301,86.5299289 L86.1180301,45.2607397 C86.1180301,43.7908945 84.9264851,42.5993496 83.45664,42.5993496 L42.3965686,42.5993496 L42.3965686,0 L125.853209,0 C127.323054,7.56290233e-15 128.514599,1.19154493 128.514599,2.66139009 L128.514599,86.5299289 L86.1180301,86.5299289 Z"
                      ></path>
                      <path
                        d="M42.3965686,0 L42.3965686,42.5993496 L3.20177394,42.5993496 C2.46685136,42.5993496 1.87107889,42.0035771 1.87107889,41.2686546 C1.87107889,40.9168323 2.01040656,40.5793274 2.25858826,40.3299586 L42.3965686,0 Z"
                      ></path>
                      <path
                        d="M128.514599,89.7533814 L128.514599,129.129279 L86.1180301,129.129279 L126.240718,88.8146855 C126.759145,88.2937784 127.601693,88.2917683 128.1226,88.8101958 C128.373528,89.0599295 128.514599,89.3993589 128.514599,89.7533814 Z"
                        transform="translate(107.316314, 107.829604) scale(-1, -1) translate(-107.316314, -107.829604) "
                      ></path>
                      <path
                        d="M42.3965686,42.5993496 L84.787335,42.5993496 C85.5222576,42.5993496 86.1180301,43.1951221 86.1180301,43.9300447 L86.1180301,86.5299289 L45.0579587,86.5299289 C43.5881136,86.5299289 42.3965686,85.338384 42.3965686,83.8685388 L42.3965686,42.5993496 Z"
                      ></path>
                    </g>
                  </g>
                  <path
                    d="M291.840637,52.401741 L275.072069,52.401741 L275.072069,84.1788901 C275.072069,86.8269991 275.732362,88.7621266 277.052966,89.9843308 C278.373571,91.2065349 280.303657,91.8940145 282.843281,92.04679 C285.166635,92.1865554 288.000069,92.1771474 291.343655,92.0185655 C291.464765,92.0128214 291.622726,92.0049606 291.817537,91.9949831 C292.065781,91.9821861 292.277333,92.1731242 292.290048,92.4213727 C292.29044,92.4290402 292.290637,92.4367165 292.290637,92.4443941 L292.290637,109.442258 C292.290578,109.671701 292.117933,109.864393 291.889868,109.889498 C291.76507,109.903235 291.66184,109.914468 291.580175,109.923197 C278.445469,111.327071 269.158836,110.02791 263.720005,106.02568 C258.183623,101.951666 255.415474,94.6694757 255.415474,84.1788901 L255.415474,52.401741 L242.608701,52.401741 C242.360172,52.401741 242.158701,52.2002692 242.158701,51.951741 L242.158701,33.9076714 C242.158701,33.6591432 242.360172,33.4576714 242.608701,33.4576714 L255.415474,33.4576714 L255.415474,20.8365829 C255.415474,20.4800483 255.625942,20.1571258 255.952129,20.013187 L274.440397,11.854764 C274.667771,11.7544292 274.933432,11.8574151 275.033767,12.0847896 C275.059024,12.1420262 275.072069,12.2039004 275.072069,12.2664619 L275.072069,33.4576714 L291.840637,33.4576714 C292.089165,33.4576714 292.290637,33.6591432 292.290637,33.9076714 L292.290637,51.951741 C292.290637,52.2002692 292.089165,52.401741 291.840637,52.401741 Z M327.931907,46.5963003 C329.760436,41.7074837 332.782544,38.0409263 336.998321,35.596518 C340.856419,33.3595 345.118583,32.1461089 349.784919,31.9563168 C349.992336,31.9478806 350.276135,31.9409612 350.636316,31.9355586 C350.88487,31.9317292 351.089387,32.1302014 351.093115,32.3787574 C351.093149,32.3810075 351.093166,32.3832577 351.093166,32.385508 L351.093166,53.1070035 C351.093148,53.5161345 350.761482,53.8478008 350.352351,53.8478008 C350.330017,53.8478008 350.307696,53.8467909 350.285454,53.8447741 C350.285454,53.8447741 350.285454,53.8447741 350.285454,53.8447741 C344.617207,53.3308112 339.52791,54.5812367 335.017424,57.5960827 C330.293722,60.7534434 327.931907,65.9986576 327.931907,73.3318825 L327.931907,109.395049 C327.931907,109.643577 327.730435,109.845049 327.481907,109.845049 L308.725312,109.845049 C308.476783,109.845049 308.275312,109.643577 308.275312,109.395049 L308.275312,33.9076714 C308.275312,33.6591432 308.476783,33.4576714 308.725312,33.4576714 L327.481907,33.4576714 C327.730435,33.4576714 327.931907,33.6591432 327.931907,33.9076714 L327.931907,46.5963003 Z M420.874567,33.4576714 L439.631162,33.4576714 C439.879691,33.4576714 440.081162,33.6591432 440.081162,33.9076714 L440.081162,109.395049 C440.081162,109.643577 439.879691,109.845049 439.631162,109.845049 L420.874567,109.845049 C420.626039,109.845049 420.424567,109.643577 420.424567,109.395049 L420.424567,100.831338 C414.532639,108.266414 406.253587,111.983896 395.587164,111.983896 C385.428666,111.983896 376.717885,108.088178 369.454559,100.296627 C362.191233,92.5050753 358.559625,82.9567486 358.559625,71.6513602 C358.559625,60.3459718 362.191233,50.7976451 369.454559,43.0060936 C376.717885,35.2145421 385.428666,31.3188248 395.587164,31.3188248 C406.253587,31.3188248 414.532639,35.0363067 420.424567,42.4713819 L420.424567,33.9076714 C420.424567,33.6591432 420.626039,33.4576714 420.874567,33.4576714 Z M384.158911,87.2343852 C388.120725,91.2065487 393.149106,93.1926007 399.244205,93.1926007 C405.339304,93.1926007 410.393081,91.1810865 414.405687,87.1579978 C418.418294,83.1349092 420.424567,77.9660816 420.424567,71.6513602 C420.424567,65.3366387 418.418294,60.1678112 414.405687,56.1447225 C410.393081,52.1216339 405.339304,50.1101197 399.244205,50.1101197 C393.149106,50.1101197 388.120725,52.1216339 384.158911,56.1447225 C380.197097,60.1678112 378.21622,65.3366387 378.21622,71.6513602 C378.21622,77.9660816 380.197097,83.1603714 384.158911,87.2343852 Z M499.171092,31.3188248 C509.431174,31.3188248 518.192747,35.2145421 525.456073,43.0060936 C532.719399,50.7976451 536.351008,60.3459718 536.351008,71.6513602 C536.351008,82.9567486 532.719399,92.5050753 525.456073,100.296627 C518.192747,108.088178 509.431174,111.983896 499.171092,111.983896 C488.504669,111.983896 480.276409,108.266414 474.486065,100.831338 L474.486065,139.95 C474.486065,140.198528 474.284593,140.4 474.036065,140.4 L455.27947,140.4 C455.030942,140.4 454.82947,140.198528 454.82947,139.95 L454.82947,33.9076714 C454.82947,33.6591432 455.030942,33.4576714 455.27947,33.4576714 L474.036065,33.4576714 C474.284593,33.4576714 474.486065,33.6591432 474.486065,33.9076714 L474.486065,42.4713819 C480.276409,35.0363067 488.504669,31.3188248 499.171092,31.3188248 Z M480.428757,87.2343852 C484.390571,91.2065487 489.418952,93.1926007 495.514051,93.1926007 C501.609149,93.1926007 506.662926,91.1810865 510.675533,87.1579978 C514.68814,83.1349092 516.694413,77.9660816 516.694413,71.6513602 C516.694413,65.3366387 514.68814,60.1678112 510.675533,56.1447225 C506.662926,52.1216339 501.609149,50.1101197 495.514051,50.1101197 C489.418952,50.1101197 484.390571,52.1216339 480.428757,56.1447225 C476.466943,60.1678112 474.486065,65.3366387 474.486065,71.6513602 C474.486065,77.9660816 476.466943,83.1603714 480.428757,87.2343852 Z M557.809864,24.2911861 C554.559144,24.2911861 551.740203,23.0944625 549.352956,20.7009793 C546.965709,18.3074962 545.772104,15.4811915 545.772104,12.2219804 C545.772104,8.96276934 546.965709,6.11100243 549.352956,3.66659412 C551.740203,1.22218582 554.559144,-3.85469434e-13 557.809864,-3.85469434e-13 C561.162168,-3.85469434e-13 564.0319,1.22218582 566.419147,3.66659412 C568.806394,6.11100243 570,8.96276934 570,12.2219804 C570,15.4811915 568.806394,18.3074962 566.419147,20.7009793 C564.0319,23.0944625 561.162168,24.2911861 557.809864,24.2911861 Z M548.057754,109.395049 L548.057754,33.9076714 C548.057754,33.6591432 548.259226,33.4576714 548.507754,33.4576714 L567.264349,33.4576714 C567.512878,33.4576714 567.714349,33.6591432 567.714349,33.9076714 L567.714349,109.395049 C567.714349,109.643577 567.512878,109.845049 567.264349,109.845049 L548.507754,109.845049 C548.259226,109.845049 548.057754,109.643577 548.057754,109.395049 Z M195.988559,55.1516866 C195.988559,57.1886935 197.334539,58.8437368 200.026541,60.1168662 C202.718543,61.3899955 205.99461,62.5103325 209.854839,63.4779108 C213.715068,64.4454891 217.575239,65.6676749 221.435469,67.1445049 C225.295698,68.6213349 228.571764,71.0911688 231.263766,74.5540805 C233.955768,78.0169923 235.301749,82.3455671 235.301749,87.5399347 C235.301749,95.3824114 232.381224,101.416954 226.540088,105.643743 C220.698952,109.870533 213.410339,111.983896 204.674031,111.983896 C189.380802,111.983896 178.84462,106.192664 173.065187,94.6100317 C173.015302,94.5100565 172.952139,94.3809002 172.875696,94.2225629 C172.767616,93.9987512 172.861462,93.7297091 173.085284,93.6216513 C173.089571,93.6195817 173.09389,93.6175803 173.09824,93.6156478 L189.631857,86.2708662 C190.066937,86.0776206 190.577265,86.2566094 190.796297,86.6792953 C190.798637,86.6838104 190.80095,86.6882636 190.803237,86.6926551 C193.378356,91.6370725 198.001921,94.1092492 204.674031,94.1092492 C211.683394,94.1092492 215.188024,91.9194996 215.188024,87.5399347 C215.188024,85.5029278 213.842043,83.8478845 211.150041,82.5747552 C208.458039,81.3016258 205.181973,80.1558266 201.321743,79.1373232 C197.461514,78.1188197 193.601343,76.8457095 189.741114,75.3179543 C185.880884,73.7901991 182.604818,71.3712897 179.912816,68.0611534 C177.220814,64.7510172 175.874833,60.6006778 175.874833,55.6100109 C175.874833,48.0730853 178.642983,42.1403916 184.179364,37.8117519 C189.715745,33.4831122 196.598024,31.3188248 204.826408,31.3188248 C211.023091,31.3188248 216.660973,32.7192461 221.740222,35.5201306 C226.351525,38.0629723 230.028556,41.4005768 232.871387,45.8808896 C233.016333,46.1093248 233.211039,46.4305935 233.455505,46.8446957 C233.581917,47.0587105 233.510836,47.334664 233.296791,47.4610256 C233.281827,47.46986 233.266363,47.4778202 233.250478,47.4848663 L216.674291,54.8375046 C216.381561,54.9673552 216.037863,54.8658268 215.862676,54.5977569 C213.375024,50.7911838 209.696293,48.8879217 204.826408,48.8879217 C202.286783,48.8879217 200.178926,49.4480902 198.502774,50.568444 C196.826622,51.6887978 195.988559,53.21653 195.988559,55.1516866 Z"
                    fill="#2F2E8B"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
        <span class="icon -node fade-in-slide-up animate">
          <svg viewBox="0 0 442.37 270.929">
            <title>Node.js</title>
            <defs>
              <clipPath id="a">
                <path
                  d="M239.03 226.605l-42.13 24.317c-1.578.91-2.546 2.59-2.546 4.406v48.668c0 1.817.968 3.496 2.546 4.406l42.133 24.336c1.575.907 3.517.907 5.09 0l42.126-24.336c1.57-.91 2.54-2.59 2.54-4.406v-48.668c0-1.816-.97-3.496-2.55-4.406l-42.12-24.317c-.79-.453-1.67-.68-2.55-.68-.88 0-1.76.227-2.55.68"
                />
              </clipPath>
              <linearGradient
                id="b"
                x1="-.348"
                x2="1.251"
                gradientTransform="rotate(116.114 53.1 202.97) scale(86.48)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset=".3" stop-color="#3E863D" />
                <stop offset=".5" stop-color="#55934F" />
                <stop offset=".8" stop-color="#5AAD45" />
              </linearGradient>
              <clipPath id="c">
                <path
                  d="M195.398 307.086c.403.523.907.976 1.5 1.316l36.14 20.875 6.02 3.46c.9.52 1.926.74 2.934.665.336-.027.672-.09 1-.183l44.434-81.36c-.34-.37-.738-.68-1.184-.94l-27.586-15.93-14.582-8.39c-.414-.24-.863-.41-1.32-.53zm0 0"
                />
              </clipPath>
              <linearGradient
                id="d"
                x1="-.456"
                x2=".582"
                gradientTransform="rotate(-36.46 550.846 -214.337) scale(132.798)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset=".57" stop-color="#3E863D" />
                <stop offset=".72" stop-color="#619857" />
                <stop offset="1" stop-color="#76AC64" />
              </linearGradient>
              <clipPath id="e">
                <path
                  d="M241.066 225.953c-.707.07-1.398.29-2.035.652l-42.01 24.247 45.3 82.51c.63-.09 1.25-.3 1.81-.624l42.13-24.336c1.3-.754 2.19-2.03 2.46-3.476l-46.18-78.89c-.34-.067-.68-.102-1.03-.102-.14 0-.28.007-.42.02"
                />
              </clipPath>
              <linearGradient
                id="f"
                x1=".043"
                x2=".984"
                gradientTransform="translate(192.862 279.652) scale(97.417)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset=".16" stop-color="#6BBF47" />
                <stop offset=".38" stop-color="#79B461" />
                <stop offset=".47" stop-color="#75AC64" />
                <stop offset=".7" stop-color="#659E5A" />
                <stop offset=".9" stop-color="#3E863D" />
              </linearGradient>
            </defs>
            <path
              fill="#689f63"
              d="M218.647 270.93c-1.46 0-2.91-.383-4.19-1.12l-13.337-7.896c-1.992-1.114-1.02-1.508-.363-1.735 2.656-.93 3.195-1.14 6.03-2.75.298-.17.688-.11.993.07l10.246 6.08c.37.2.895.2 1.238 0l39.95-23.06c.37-.21.61-.64.61-1.08v-46.1c0-.46-.24-.87-.618-1.1l-39.934-23.04c-.37-.22-.86-.22-1.23 0l-39.926 23.04c-.387.22-.633.65-.633 1.09v46.1c0 .44.24.86.62 1.07l10.94 6.32c5.94 2.97 9.57-.53 9.57-4.05v-45.5c0-.65.51-1.15 1.16-1.15h5.06c.63 0 1.15.5 1.15 1.15v45.52c0 7.92-4.32 12.47-11.83 12.47-2.31 0-4.13 0-9.21-2.5l-10.48-6.04c-2.59-1.5-4.19-4.3-4.19-7.29v-46.1c0-3 1.6-5.8 4.19-7.28l39.99-23.07c2.53-1.43 5.89-1.43 8.4 0l39.94 23.08c2.58 1.49 4.19 4.28 4.19 7.28v46.1c0 2.99-1.61 5.78-4.19 7.28l-39.94 23.07c-1.28.74-2.73 1.12-4.21 1.12"
            />
            <path
              fill="#689f63"
              d="M230.987 239.164c-17.48 0-21.145-8.024-21.145-14.754 0-.64.516-1.15 1.157-1.15h5.16c.57 0 1.05.415 1.14.978.78 5.258 3.1 7.91 13.67 7.91 8.42 0 12-1.902 12-6.367 0-2.57-1.02-4.48-14.1-5.76-10.94-1.08-17.7-3.49-17.7-12.24 0-8.06 6.8-12.86 18.19-12.86 12.79 0 19.13 4.44 19.93 13.98.03.33-.09.65-.31.89-.22.23-.53.37-.85.37h-5.19c-.54 0-1.01-.38-1.12-.9-1.25-5.53-4.27-7.3-12.48-7.3-9.19 0-10.26 3.2-10.26 5.6 0 2.91 1.26 3.76 13.66 5.4 12.28 1.63 18.11 3.93 18.11 12.56 0 8.7-7.26 13.69-19.92 13.69m48.66-48.89h1.34c1.1 0 1.31-.77 1.31-1.22 0-1.18-.81-1.18-1.26-1.18h-1.38zm-1.63-3.78h2.97c1.02 0 3.02 0 3.02 2.28 0 1.59-1.02 1.92-1.63 2.12 1.19.08 1.27.86 1.43 1.96.08.69.21 1.88.45 2.28h-1.83c-.05-.4-.33-2.6-.33-2.72-.12-.49-.29-.73-.9-.73h-1.51v3.46h-1.67zm-3.57 4.3c0 3.58 2.89 6.48 6.44 6.48 3.58 0 6.47-2.96 6.47-6.48 0-3.59-2.93-6.44-6.48-6.44-3.5 0-6.44 2.81-6.44 6.43m14.16.03c0 4.24-3.47 7.7-7.7 7.7-4.2 0-7.7-3.42-7.7-7.7 0-4.36 3.58-7.7 7.7-7.7 4.15 0 7.69 3.35 7.69 7.7"
            />
            <path
              fill="#333"
              fill-rule="evenodd"
              d="M94.936 90.55c0-1.84-.97-3.53-2.558-4.445l-42.356-24.37c-.715-.42-1.516-.64-2.328-.67h-.438c-.812.03-1.613.25-2.34.67L2.562 86.105C.984 87.025 0 88.715 0 90.555l.093 65.64c0 .91.47 1.76 1.27 2.21.78.48 1.76.48 2.54 0l25.18-14.42c1.59-.946 2.56-2.618 2.56-4.44V108.88c0-1.83.97-3.52 2.555-4.43l10.72-6.174c.796-.46 1.67-.688 2.56-.688.876 0 1.77.226 2.544.687l10.715 6.172c1.586.91 2.56 2.6 2.56 4.43v30.663c0 1.82.983 3.5 2.565 4.44l25.164 14.41c.79.47 1.773.47 2.56 0 .776-.45 1.268-1.3 1.268-2.21zm199.868 34.176c0 .457-.243.88-.64 1.106l-14.548 8.386c-.395.227-.883.227-1.277 0l-14.55-8.386c-.4-.227-.64-.65-.64-1.106V107.93c0-.458.24-.88.63-1.11l14.54-8.4c.4-.23.89-.23 1.29 0l14.55 8.4c.4.23.64.652.64 1.11zM298.734.324c-.794-.442-1.76-.43-2.544.027-.78.46-1.262 1.3-1.262 2.21v65c0 .64-.34 1.23-.894 1.55-.55.32-1.235.32-1.79 0L281.634 63c-1.58-.914-3.526-.914-5.112 0l-42.37 24.453c-1.583.91-2.56 2.6-2.56 4.42v48.92c0 1.83.977 3.51 2.56 4.43l42.37 24.47c1.582.91 3.53.91 5.117 0l42.37-24.48c1.58-.92 2.56-2.6 2.56-4.43V18.863c0-1.856-1.01-3.563-2.63-4.47zm141.093 107.164c1.574-.914 2.543-2.602 2.543-4.422V91.21c0-1.824-.97-3.507-2.547-4.425l-42.1-24.44c-1.59-.92-3.54-.92-5.13 0l-42.36 24.45c-1.59.92-2.56 2.6-2.56 4.43v48.9c0 1.84.99 3.54 2.58 4.45l42.09 23.99c1.55.89 3.45.9 5.02.03l25.46-14.15c.8-.45 1.31-1.3 1.31-2.22 0-.92-.49-1.78-1.29-2.23l-42.62-24.46c-.8-.45-1.29-1.3-1.29-2.21v-15.34c0-.916.48-1.76 1.28-2.216l13.26-7.65c.79-.46 1.76-.46 2.55 0l13.27 7.65c.79.45 1.28 1.3 1.28 2.21v12.06c0 .91.49 1.76 1.28 2.22.79.45 1.77.45 2.56-.01zm0 0"
            />
            <path
              fill="#689f63"
              fill-rule="evenodd"
              d="M394.538 105.2c.3-.177.676-.177.98 0l8.13 4.69c.304.176.49.5.49.85v9.39c0 .35-.186.674-.49.85l-8.13 4.69c-.304.177-.68.177-.98 0l-8.125-4.69c-.31-.176-.5-.5-.5-.85v-9.39c0-.35.18-.674.49-.85zm0 0"
            />
            <g clip-path="url(#a)" transform="translate(-78.306 -164.016)">
              <path
                fill="url(#b)"
                d="M331.363 246.793l-118.715-58.19-60.87 124.174L270.49 370.97zm0 0"
              />
            </g>
            <g clip-path="url(#c)" transform="translate(-78.306 -164.016)">
              <path
                fill="url(#d)"
                d="M144.07 264.004l83.825 113.453 110.86-81.906-83.83-113.45zm0 0"
              />
            </g>
            <g clip-path="url(#e)" transform="translate(-78.306 -164.016)">
              <path
                fill="url(#f)"
                d="M197.02 225.934v107.43h91.683v-107.43zm0 0"
              />
            </g>
          </svg>
        </span>
        <span class="icon -nginx fade-in-slide-up animate">
          <svg viewBox="0 0 512 108">
            <title>Nginx</title>
            <g fill="#090">
              <path
                d="M96.174 107.15c-2.89 0-5.734-1.124-7.86-3.254L22.544 38.12v57.917c0 6.14-4.975 11.114-11.114 11.114-6.135 0-11.114-4.975-11.114-11.114v-84.75c0-4.499 2.712-8.549 6.864-10.269a11.096 11.096 0 0 1 12.11 2.41L85.06 69.204V11.287c0-6.14 4.975-11.114 11.114-11.114 6.14 0 11.114 4.975 11.114 11.114v84.75a11.12 11.12 0 0 1-11.114 11.114M147.64.28l-3.054 5.7-23.619 42.925-3.054 5.42 3.054 5.414 23.62 41.54 3.191 5.694h61.824l3.054-6.25L230.3 65.157l7.918-16.115h-17.92l-45.149.138c-5.872-.08-11.274 5.241-11.274 11.114 0 5.872 5.402 11.198 11.274 11.114l27.229-.138-6.668 13.474H160.7l-17.369-30.563 17.507-31.674h37.24l8.682 17.817h22.37L215.03 6.535 211.971.28h-64.33M260.232.142c-5.824.071-11.051 5.433-10.976 11.252v28.963h22.228V11.394C271.554 5.48 266.14.067 260.232.142M295.859 107.364a11.117 11.117 0 0 1-11.11-11.114V11.5c0-6.139 4.975-11.113 11.114-11.113 6.14 0 11.114 4.974 11.114 11.114v57.916L372.749 3.64a11.102 11.102 0 0 1 12.11-2.41 11.117 11.117 0 0 1 6.859 10.27v84.75c0 6.138-4.975 11.113-11.114 11.113-6.14 0-11.114-4.975-11.114-11.114V38.334l-65.772 65.776a11.1 11.1 0 0 1-7.86 3.254M474.044 53.79l34.573-34.447c4.348-4.33 4.361-11.368.027-15.72-4.33-4.348-11.363-4.357-15.715-.027l-34.626 34.507-34.627-34.507c-4.352-4.334-11.385-4.32-15.714.027-4.335 4.352-4.322 11.39.022 15.72l34.573 34.448-34.471 34.35c-4.352 4.335-4.361 11.368-.027 15.715a11.059 11.059 0 0 0 7.873 3.272c2.837 0 5.673-1.08 7.842-3.245l34.529-34.404 34.524 34.404a11.075 11.075 0 0 0 7.846 3.245c2.854 0 5.7-1.089 7.873-3.272 4.33-4.347 4.321-11.38-.027-15.714L474.044 53.79M260.232 107.048c-5.824-.07-11.051-5.432-10.976-11.251V49.274h22.228v46.523c.07 5.908-5.344 11.322-11.252 11.251"
              />
            </g>
          </svg>
        </span>
        <span class="icon -wagtail fade-in-slide-up animate">
          <svg viewBox="0 0 256 316">
            <title>Wagtail</title>
            <g>
              <path
                d="M214.75,46.25 C218.339851,46.25 221.25,43.3398509 221.25,39.75 C221.25,36.1601491 218.339851,33.25 214.75,33.25 C211.160149,33.25 208.25,36.1601491 208.25,39.75 C208.25,43.3398509 211.160149,46.25 214.75,46.25 Z M223,102.25 C223,102.25 214.75,60.75 160.75,72 C155.25,53.25 156.25,39.5 168.25,26.75 C184.5,9.5 210,19 210,19 L210,4.75 C201,0.75 192.5,3.55271368e-15 183,3.55271368e-15 C148.25,3.55271368e-15 129,26 120.75,43.5 L23,223.25 L50.5,218 L0,315.5 L35.25,309.25 L62.25,232.5 C138.75,232.5 236.75,205 223,102.25 Z M256,67.5 L234.5,46.75 L217.5,67.5 L256,67.5 Z M75,210.25 C75,210.25 77.5,209.75 82,208.75 C86.5,207.75 92.75,206.25 100.25,204.25 C104,203.25 108,202 112.25,200.5 C116.5,199 121,197.5 125.25,195.5 C129.75,193.75 134.25,191.5 138.75,189 C143.25,186.5 147.5,183.75 151.5,180.5 C152.5,179.75 153.5,179 154.5,178 L157.5,175.5 C159.25,173.75 161.25,172 163,170 C164.75,168.25 166.25,166.25 167.75,164.25 C168.5,163.25 169.25,162.25 170,161.25 L171,159.75 L172,158.25 C172.5,157.25 173.25,156.25 173.75,155.25 C174.25,154.25 174.75,153.25 175.5,152.25 C175.75,151.75 176,151.25 176.25,150.75 C176.5,150.25 176.75,149.75 177,149.25 C177.5,148.25 178,147.25 178.25,146.25 C179,144.25 179.75,142.25 180.5,140.25 C181,138.25 181.75,136.25 182.25,134.5 C182.75,132.75 183,130.75 183.5,129.25 C183.75,127.5 184,126 184.25,124.25 C184.5,122.75 184.75,121.25 184.75,120 C185,118.75 185,117.5 185.25,116.25 C185.5,111.75 185.5,109.25 185.5,109.25 L189.5,109.5 C189.5,109.5 189.25,112.25 189,116.75 C188.75,118 188.75,119.25 188.5,120.5 C188.25,122 188.25,123.5 187.75,125 C187.5,126.5 187,128.25 186.75,130 C186.25,131.75 185.75,133.5 185.25,135.5 C184.75,137.5 184,139.25 183.25,141.5 C182.5,143.5 181.75,145.5 180.75,147.75 C180.25,148.75 179.75,149.75 179.25,150.75 C179,151.25 178.75,151.75 178.5,152.25 C178.25,152.75 178,153.25 177.75,153.75 C177.25,154.75 176.5,155.75 176,157 C175.25,158 174.75,159 174,160 C173.75,160.5 173.25,161 173,161.5 L172,163 C171.25,164 170.5,165 169.75,166 C168,168 166.5,170 164.5,171.75 C162.75,173.75 160.75,175.25 158.75,177.25 L155.75,179.75 C154.75,180.5 153.75,181.25 152.5,182 C148.25,185 143.75,187.75 139.25,190.25 C134.75,192.5 130,194.75 125.5,196.5 C121,198.25 116.5,199.75 112.25,201 C108,202.25 104,203.5 100,204.25 C92.5,206 86,207.5 81.5,208.25 C77.5,209.75 75,210.25 75,210.25 L75,210.25 Z"
                fill="#000000"
              ></path>
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style lang='sass' scoped>
@import '@/assets/_variables.sass'

.about-info
  width: 100%
  display: flex
  flex-direction: column
  flex: 1 1 100%
  justify-content: space-around

.facts-row
  display: flex
  align-items: center
  justify-content: center
  margin: 30px auto 60px
  width: 100%
  max-width: 1000px

  @media (max-width: 600px)
    flex-direction: column

.fact-wrapper
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  flex: 1 1 33%
  border-right: 2px solid $c-gunmetal

  @media (max-width: 600px)
    border: none
    margin-bottom: 30px

    &:last-of-type
      margin-bottom: 0

  &:last-of-type
    border-right: 0

  > .top
    display: flex
    align-items: center
    justify-content: space-between

    > .icon
      max-width: 30px
      max-height: 30px
      width: 100%
      height: 100%
      fill: $c-bittersweet
      margin-top: 8px

      @media (max-width: 900px)
        max-width: 25px
        max-height: 25px

      @media (max-width: 600px)
        max-width: 30px
        max-height: 30px

    > .fact
      line-height: 1.5
      font-size: 40px
      margin-left: 10px
      color: $c-bittersweet

      @media (max-width: 900px)
        font-size: 32px

      @media (max-width: 600px)
        font-size: 36px

  > .more
    margin-left: 3px

  > .text
    font-weight: 700
    font-size: 18px

    @media (max-width: 900px)
      font-size: 14px

    @media (max-width: 600px)
      font-size: 16px

.author-row
  max-width: 600px
  margin: 0 auto
  display: flex
  align-items: center
  justify-content: space-between

  @media (max-width: 600px)
    flex-direction: column

  @media (max-width: 800px)
    justify-content: center

  > .info
    padding-left: 30px
    flex: 0 0 50%
    font-weight: 500
    font-size: 18px
    opacity: 0
    visibility: hidden
    transform: translateX(100px)

    @media (max-width: 600px)
      margin-top: 40px

  .author-image
    overflow: hidden
    display: flex
    justify-content: center
    opacity: 0
    visibility: hidden
    transform: translateX(-100px)

    .image
      height: 100%
      width: 100%
      max-width: 180px
      max-height: 180px
      border-radius: 50%
      object-fit: cover
      object-position: center

      @media (max-width: 800px)
        max-width: 160px
        max-height: 160px

      @media (max-width: 600px)
        max-width: 140px
        max-height: 140px

      @media (min-width: 1500px)
        max-width: 200px
        max-height: 200px

.languages-row
  display: flex
  align-items: center
  justify-content: flex-start
  flex-wrap: wrap
  width: 100%
  margin: 80px auto 30px

  @media (max-width: 1100px)
    justify-content: center

  > .icon
    flex: 1 1 auto
    overflow: hidden
    margin: 0 5px 15px
    opacity: 0
    visibility: hidden
    transform: translateY(100px)

    @media (max-width: 1100px)
      flex: 0 1 auto

    &.-js
      margin: 0 10px 15px

    &.-webpack
      margin: 0 15px 15px

    &.-strapi
      margin: 0 10px 15px

      > svg
        max-width: 150px

    &.-node, &.-nginx
      margin: 0 10px 15px

      > svg
        max-width: 130px

    &.-wagtail
      > svg
        max-height: 65px

    > svg
      width: 100%
      height: 100%
      max-width: 70px
      max-height: 70px
      opacity: 0.5
      transition: $normal-transition

      &:hover
        opacity: 1
</style>